import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ExternalAuthService } from '@context/frontend/user';

@Component({
	standalone: true,
	selector: 'ctx-logout',
	template: '',
})
export class LogoutComponent implements OnInit {
	private readonly externalAuthService = inject(ExternalAuthService);
	private readonly router = inject(Router);

	ngOnInit() {
		this.signOut();
	}

	readonly signOut = () =>
		this.externalAuthService.signOut().finally(() =>
			this.router.navigate(['/'], {
				queryParams: {
					title: 'external.viewer.exited.title',
					description: 'external.viewer.exited.description',
				},
			}),
		);
}
